import AsyncStorage from '@react-native-async-storage/async-storage'
import { flow, Instance, types } from 'mobx-state-tree'
import { Platform } from 'react-native'

import { appUserSessionRefresher } from '@jfs/network'
import Config from 'react-native-config'
import { getQrCodeRequest } from '../../data/request/getQrCodeRequest'
import { addUser } from '../../network/addUser'
import { ApiAuth } from '../../network/ApiAuth'
import { changePasswordVerifyOtp } from '../../network/changePasswordVerifyOtp'
import { createIntent } from '../../network/createIntent'
import { createMerchantReq } from '../../network/createMerchantReq'
import { createUserDeviceReq } from '../../network/createUserDevice'
import { deleteUser } from '../../network/deleteUser'
import { downloadQr } from '../../network/downloadQr'
import { downloadUniversalQr } from '../../network/downloadUniversalQr'
import { fetchIFSC } from '../../network/fetchIFSC'
import { forgotPassword } from '../../network/forgotPassword'
import { generateQr } from '../../network/generarteQr'
import { generateOTP } from '../../network/generateOTP'
import { generateOtpOnSignUp } from '../../network/generateOtpOnSignUp'
import { getAccDetails } from '../../network/getAccDetails'
import { GetMerchantMetaData } from '../../network/GetMerchantMetaData'
import { defaultSoundSdk, getNotifConfig } from '../../network/getNotifConfig'
import { getSplitPayemntEnabledForMid } from '../../network/getSplitPaymentEnabledForMid'
import { getSubMerchantsWithMid } from '../../network/getSubMerchantsWithMid'
import { loginVerifyOtp } from '../../network/loginVerifyOtp'
import { onboardAgent } from '../../network/onboardAgent'
import { onBoardmerchant } from '../../network/onBoardMercant'
import { profileFromEntityJSON } from '../../network/parsers/GetMerchantParser'
import { removeBankAccountReq } from '../../network/removeBankAccountReq'
import { searchEntity } from '../../network/searchEntity'
import { searchMerchantsWithMobile } from '../../network/searchMerchantsWithMobile'
import { setPasswordOnIDAMReq } from '../../network/setPasswordOnIDAM'
import { signup } from '../../network/signup'
import { updateKycConsentApi } from '../../network/updateKycConsentApi'
import { updateUser } from '../../network/updateUser'
import { updateUserDeviceReq } from '../../network/updateUserDevice'
import {
  compareBusiness,
  downloadQrPdfFile,
  getBillPayErrorMessage,
  getErrorMsg,
  getFromStore,
  isSmallDevice,
  NotificationServiceModule,
  shouldAvoidUserEntityCall,
  storeData,
} from '../../util/util'
import { MerchantStatus } from '../static/data'
import { customError } from '../static/strings'
import { RootStore } from '../store'
import { appAuthGenerate, appAuthVerify } from './../../network/AppAuthPkce'
import { getBranchDetailsByIfsc } from './../../network/getBranchDetailsByIfsc'
import { getUserAccountDetails } from './../../network/getUserAccountDetails'
import { searchIfscThroughBranchIdRequest } from './../../network/searchIfscThroughBranchIdRequest'
import { isOsMobile, pkceGetCodeVerifier } from './../../util/util'
import { Document, documentV2 } from './Document'
import { BankIfscData } from './IfscData'
import { Merchant, MerchantType } from './Merchant'
import { Notification, notificationData0V2, notificationDataV2, NotificationV2 } from './Notification'
import { Session, sessionDataV2, sessionDataV21 } from './Session'

export enum Role {
  Admin = 'Admin',
  Basic = 'Basic',
  Finance = 'Finance',
  Ops = 'Ops',
  Support = 'Support',
}

const SUCCESS_RESPONSE_STRING = 'SUCCESS'

const REACT_APP_PKCE_ENABLED = isOsMobile()
  ? Config.REACT_APP_PKCE_ENABLED
  : window?._env_?.REACT_APP_PKCE_ENABLED ?? ''

// const getPermissions = (data: any): string[] => {
//   return [
//     data.dashboardFlag ? 'Dashboard' : '',
//     data.mapMyDevFlag ? 'Map My Device' : '',
//     data.holdRelFlag ? 'Hold Release' : '',
//     data.refReceiptsFlag ? 'Refund Receipts' : '',
//     data.accPaymentFlag ? 'Account Payments' : '',
//     data.userManageflag ? 'User Management' : '',
//     data.storeManageFlag ? 'Store Management' : '',
//     data.accManageFlag ? 'Account Management' : '',
//     data.reportFlag ? 'Report Management' : '',
//     data.mpaReportFlag ? 'MPA Report' : '',
//   ]
// }

export const getUserBody = (mUser: any): any => {
  return {
    mid: mUser.mid,
    merchantMobNumber: mUser.merchantMobNumber,
    mercBussName: mUser.mercBussName,
    mercTerminalId: mUser.mercTerminalId,
    mercUuid: mUser.mercUuid,
    userMobNo: mUser.userMobNo,
    userFname: mUser.userFname,
    userLname: mUser.userLname,
    userAccess: {
      dashboardFlag: mUser.dashboardFlag,
      mapMyDevFlag: mUser.mapMyDevFlag,
      holdRelFlag: mUser.holdRelFlag,
      refReceiptsFlag: mUser.refReceiptsFlag,
      accPaymentFlag: mUser.accPaymentFlag,
      userManageflag: mUser.userManageflag,
      storeManageFlag: mUser.storeManageFlag,
      accManageFlag: mUser.accManageFlag,
      reportFlag: mUser.reportFlag,
      mpaReportFlag: mUser.mpaReportFlag,
    },
  }
}
export const getUpdateUserBody = (mUser: any): any => {
  return {
    userId: mUser.userId,
    mid: mUser.mid,
    userFname: mUser.userFname,
    userLname: mUser.userLname,
    userAccess: {
      dashboardFlag: mUser.dashboardFlag,
      mapMyDevFlag: mUser.mapMyDevFlag,
      holdRelFlag: mUser.holdRelFlag,
      refReceiptsFlag: mUser.refReceiptsFlag,
      accPaymentFlag: mUser.accPaymentFlag,
      userManageflag: mUser.userManageflag,
      storeManageFlag: mUser.storeManageFlag,
      accManageFlag: mUser.accManageFlag,
      reportFlag: mUser.reportFlag,
      mpaReportFlag: mUser.mpaReportFlag,
    },
  }
}

const User = types
  .model('User', {
    id: types.string,
    documents: types.array(Document),
    firstName: types.string,
    institutionId: types.string,
    lastName: types.string,
    notifications: types.array(Notification),
    permissions: types.array(types.string), // ['createUser','updateSettings']
    role: types.enumeration(Object.values(Role)),
    status: types.enumeration(Object.values(MerchantStatus)),
    session: Session,
    ifscData: types.array(BankIfscData),
    inactiveTime: types.number,
    selectedMid: types.string,
    isSmid: types.optional(types.boolean, false),
    selectedTid: types.string,
    merchants: types.optional(types.array(Merchant), []),
    consentCheckboxChecked: types.boolean,
    showRegeneratedQr: types.optional(types.boolean, false),
    secondaryUser: types.optional(types.boolean, false),
  })
  .actions((self: any) => ({
    signUp: flow(function* signUp(userInfo: any) {
      console.log(userInfo)
      //FIXME: Phase 2 add signUp API
      let response
      try {
        response = yield signup(RootStore.user.session.getTokens)
        const { status } = response
        console.log(status)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),

    changePasswordVerifyOTP: flow(function* changePasswordVerifyOTP(otp: string) {
      console.log(otp)
      let response
      try {
        response = yield changePasswordVerifyOtp(RootStore.user.session.getTokens)
        const { status } = response
        console.log(status)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    searchEntity: flow(function* searchEntityByMid(mid?: string) {
      const selectedMid = mid ?? self.selectedMid
      try {
        const data = yield searchEntity(
          RootStore.user?.session?.getTokens,
          RootStore.user?.session?.userAccessToken,
          selectedMid,
        )

        const { disableBillPayment, ...merchantObj }: any = profileFromEntityJSON(data, mid || self.selectedMid)
        RootStore.updateSelectedMerchant(merchantObj)
        const contact = merchantObj?.contact
        RootStore.settings.metaData.updateSelectedMercMobileNumber(contact?.mobile ?? 'NA')
        const fullnameArr = merchantObj.name?.split(' ') ?? []
        const [firstName, ...lastName] = fullnameArr
        const userDetails = {
          firstName: firstName ?? '',
          lastName: lastName?.join(' ') ?? '',
          name: merchantObj.name,
          mobile: contact?.mobile,
          email: contact?.email,
          shopName: merchantObj?.businessName,
          businessType: merchantObj?.type,
          address: {
            registeredAddress: contact?.registeredAddress,
            registeredState: contact?.registeredState,
            registeredCity: contact?.registeredCity,
            registeredCountry: contact?.registeredCountry,
            registeredPinCode: contact?.registeredPinCode,
            latitude: contact?.latitude,
            longitude: contact?.longitude,
          },
          id: selectedMid,
          disableBillPayment: disableBillPayment,
        }
        RootStore.billPayments.updateUserDetails(userDetails)
        const own = self
        own.id = selectedMid
        return data
      } catch (error) {
        const message = getBillPayErrorMessage(error)
        const customError = {
          message,
        }
        // RootStore?.response?.setMessage(message)
        throw customError
      }
    }),

    onboardAgent: flow(function* onboardNewAgent() {
      try {
        const mid = self.selectedMid
        const response = yield onboardAgent(
          RootStore.user?.session?.getTokens,
          RootStore.user?.session?.userAccessToken,
          mid,
          RootStore.billPayments.user,
        )
        return response
      } catch (error) {
        const message = getBillPayErrorMessage(error)
        const cusError = {
          message,
        }
        RootStore?.response?.setMessage(message)
        throw cusError
      }
    }),
    fetchSubMerchants: flow(function* fetchSubMerchants(mid: string) {
      if (!shouldAvoidUserEntityCall) {
        try {
          const response = yield getSubMerchantsWithMid(mid || self.selectedMid, RootStore.user.session.getTokens)
          self.isSmid = response?.isSmid
          let newMerchants: any = []
          self.merchants.forEach((element) => {
            if (element.mid === mid && response?.isSmid) {
              element.subMids = response.midList
              newMerchants.push(element)
            } else {
              newMerchants.push(element)
            }
          })
          self.merchants = JSON.parse(JSON.stringify(newMerchants))
        } catch (e) {
          self.isSmid = false
          RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
          throw new Error(e?.data?.error?.message ?? 'Error while processing request')
        }
      }
    }),
    loginVerifyOTP: flow(function* loginVerifyOTP(otp: string, mobileNumber: string) {
      let response
      try {
        response = yield loginVerifyOtp(
          otp,
          mobileNumber,
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
        )
        const { status } = response
        console.log(status)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    forgotResetPassword: flow(function* forgotResetPassword(mobile: string, password: string, otp: string) {
      let response
      try {
        const responseData = yield forgotPassword(mobile, password, otp, RootStore.user.session.getTokens)
        //To show same old password and new password or wrong otp use case error
        if (responseData?.status !== 'SUCCESS') {
          RootStore?.response?.setMessage(responseData?.error?.message ?? customError.errorOccured)
        }
        // const data = yield RootStore.user.session.verifyCredentials(mobile, password)
        response = responseData
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),

    onboardMerchant: flow(function* onboardMerchant(mobile: string, password: string, otp: string) {
      let response
      try {
        const responseData = yield onBoardmerchant(mobile, password, otp, RootStore.user.session.getTokens)
        if (responseData?.status === 'SUCCESS') {
          yield RootStore.user.session.verifyCredentials(mobile, password, false) // to get user auth tokens
          self.selectedMid = responseData?.response?.details?.mid
        } else {
          throw responseData
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),

    generateOtp: flow(function* generateOtp(mobileNumber: string) {
      let response
      RootStore.settings.metaData.setIsUserNotFoundInIdam(false)
      try {
        const own = self
        if (isOsMobile() && !!REACT_APP_PKCE_ENABLED) {
          const codeVerifier = pkceGetCodeVerifier(64)
          let resAppAuthGen = yield appAuthGenerate(codeVerifier.toString(), RootStore.user.session.getTokens)
          if (resAppAuthGen?.status === 'SUCCESS' && resAppAuthGen?.authorizationCode?.length > 0) {
            own.session.authorizationCode = resAppAuthGen?.authorizationCode
            let resAppAuthVerify = yield appAuthVerify(
              own.session.authorizationCode,
              codeVerifier.toString(),
              RootStore.user.session.getTokens,
            )
            if (resAppAuthVerify.status === 'SUCCESS') {
              own.session.appAccessToken = resAppAuthVerify?.session?.accessToken?.tokenValue ?? ''
              own.session.appRefreshToken = resAppAuthVerify?.session?.refreshToken?.tokenValue ?? ''
              own.session.appIdToken = resAppAuthVerify?.session?.appIdentifierToken ?? ''
              own.session.appAccessTokenExpiry = resAppAuthVerify?.session?.accessToken?.expiresIn ?? -1
              own.session.appRefreshTokenExpiry = resAppAuthVerify?.session?.refreshToken?.expiresIn ?? -1
            }
          }
        } else {
          let responseAppAuth = yield ApiAuth(mobileNumber, RootStore.user.session.getTokens)
          if (responseAppAuth.status === 'SUCCESS') {
            own.session.appAccessToken = responseAppAuth?.session?.accessToken?.tokenValue
            own.session.appIdToken = responseAppAuth?.session?.appIdentifierToken
          }
        }
        const responseData = yield generateOTP(mobileNumber, RootStore.user.session.getTokens)
        console.log('===> generateOTP response', responseData)
        // try {
        //   let resCheckUserOnIDAM
        //   resCheckUserOnIDAM = yield checkUserOnIDAMReq(mobileNumber, RootStore.user.session.getTokens)
        //   if (resCheckUserOnIDAM.status && resCheckUserOnIDAM.status === 'SUCCESS') {
        //     const responseData = yield generateOTP(mobileNumber, RootStore.user.session.getTokens)
        //     console.log('===> generateOTP response', responseData)
        //   }
        // } catch (e2) {
        //   // Handling it in catch as api throws 400 for this case
        //   if (e2 && e2?.data && e2?.data?.error && e2?.data?.error?.code && e2?.data?.error?.code === '33410') {
        //     // User Not a registered flow - call auth api with mode 1 and call set api at last
        //     const responseData = yield generateOtpOnNonIDAMReq(mobileNumber, RootStore.user.session.getTokens)
        //     if (responseData && responseData.status && responseData.status === 'INITIATED') {
        //       RootStore.settings.metaData.setIsUserNotFoundInIdam(true)
        //     }
        //   } else {
        //     throw e2
        //   }
        // }
      } catch (e4) {
        RootStore?.response?.setMessage(e4?.data?.error?.message ?? customError.errorOccured)
        throw e4?.data?.error?.message ?? 'Error while processing request'
      }
      return response
    }),

    generateOtpOnSignup: flow(function* generateOtpOnSignup(mobileNumber: string) {
      let response
      try {
        const own = self
        if (isOsMobile() && !!REACT_APP_PKCE_ENABLED) {
          const codeVerifier = pkceGetCodeVerifier(64)
          let resAppAuthGen = yield appAuthGenerate(codeVerifier.toString(), RootStore.user.session.getTokens)
          if (resAppAuthGen?.status === 'SUCCESS' && resAppAuthGen?.authorizationCode?.length > 0) {
            own.session.authorizationCode = resAppAuthGen?.authorizationCode
            let resAppAuthVerify = yield appAuthVerify(
              own.session.authorizationCode,
              codeVerifier.toString(),
              RootStore.user.session.getTokens,
            )
            if (resAppAuthVerify.status === 'SUCCESS') {
              own.session.appAccessToken = resAppAuthVerify?.session?.accessToken?.tokenValue ?? ''
              own.session.appRefreshToken = resAppAuthVerify?.session?.refreshToken?.tokenValue ?? ''
              own.session.appIdToken = resAppAuthVerify?.session?.appIdentifierToken ?? ''
              own.session.appAccessTokenExpiry = resAppAuthVerify?.session?.accessToken?.expiresIn ?? -1
              own.session.appRefreshTokenExpiry = resAppAuthVerify?.session?.refreshToken?.expiresIn ?? -1
            }
          }
        } else {
          let responseAppAuth = yield ApiAuth(mobileNumber, RootStore.user.session.getTokens)
          if (responseAppAuth.status === 'SUCCESS') {
            own.session.appAccessToken = responseAppAuth?.session?.accessToken?.tokenValue
            own.session.appIdToken = responseAppAuth?.session?.appIdentifierToken
          }
        }
        const responseData = yield generateOtpOnSignUp(mobileNumber, RootStore.user.session.getTokens)
        console.log(responseData)
      } catch (e) {
        const error = e?.data?.error
        RootStore?.response?.setMessage(getErrorMsg(error?.code, error?.message) ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    updateReadStatus(): void {
      self.notifications.forEach((element) => {
        const own = element
        own.isRead = true
      })
    },
    updateVpaFromStore: flow(function* searchMerchants() {
      const vpaData = yield getFromStore('vpa')
      if (vpaData && vpaData?.length > 0) {
        const parsedVpa = JSON.parse(vpaData)
        const vpaId = parsedVpa[self.selectedMid]
        if (vpaId) {
          RootStore.settings.metaData.updateVpa(vpaId)
        }
      }
    }),
    searchMerchants: flow(function* searchMerchants() {
      const storedMobile =
        Platform.OS === 'web' ? JSON.parse(window?.localStorage?.getItem('userMobileNumber') ?? '') : ''
      const mobileNumber =
        RootStore.settings.metaData.mobileNumber.length > 0 ? RootStore.settings.metaData.mobileNumber : storedMobile
      if (!mobileNumber) {
        return
      }
      let data
      try {
        data = yield searchMerchantsWithMobile(
          RootStore.user.session.getTokens,
          RootStore.settings.metaData.mobileNumber.length > 0 ? RootStore.settings.metaData.mobileNumber : mobileNumber,
        )
        self.merchants = data
        const merchantData = window?.localStorage?.getItem('midData')
        const merchantJsonData = merchantData && JSON.parse(merchantData)
        const selectedMerchant =
          merchantJsonData ?? self.merchants.find((element) => element?.status === 'Active') ?? self.merchants[0]
        const username = self.merchants?.length === 1 ? self.merchants[0]?.businessName : selectedMerchant?.businessName
        if (isSmallDevice()) {
          const selectedMerchantName =
            self.merchants.find((item) => item.mid === self.selectedMid)?.businessName ??
            RootStore.settings.metaData.selectedMercName
          self.selectedMid = self.selectedMid ? self.selectedMid : selectedMerchant?.mid ?? ''
          RootStore.settings.metaData.updateSelectedMercName(
            selectedMerchantName ? selectedMerchantName : username ?? '',
          )
        } else {
          self.selectedMid = selectedMerchant?.mid ?? ''
          RootStore.settings.metaData.updateSelectedMercName(username ?? '')
        }
        self.selectedTid = selectedMerchant?.tId ?? ''
        RootStore.settings.metaData.updateSelectedMercStatus(selectedMerchant?.status ?? '')
        yield (self as any).updateVpaFromStore()
        const midData = {
          mid: self.selectedMid,
          tId: self.selectedTid,
          businessName: username ?? '',
          status: RootStore.settings.metaData?.selectedMerchantStatus ?? '',
        }
        window?.localStorage?.setItem('midData', JSON.stringify(midData))
      } catch (e) {
        if (isSmallDevice() || isOsMobile()) {
          if (isOsMobile()) {
            AsyncStorage.multiRemove(['sessionData', 'enableLockLater', 'lockEnabled', 'fcmToken'])
          } else {
            window?.localStorage.removeItem('sessionData')
            window?.localStorage.removeItem('midData')
          }
          yield RootStore.user.session.updateAppSessionData('', '', -1, -1, '')
          yield RootStore.user.session.updateUserSessionData('', '', '', -1, -1, '')
          RootStore.settings.metaData.updateSelectedMercName('')
          RootStore.user.updateSelectedMercMid('')
        }
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return data
    }),

    getAllMerchantMetaData: flow(function* getAllMerchantMetaData(mid: string) {
      let data
      try {
        if (mid && mid?.length > 0) {
          data = yield GetMerchantMetaData(mid, RootStore.user.session.getTokens)
          self.merchants = data

          let isMidAvailableAndUnblocked: boolean = false
          const validMerchantData = RootStore?.user?.merchantData()

          //Enter only if there are merchant with status as ACTIVE
          if (validMerchantData.length > 0) {
            const previouslySelectedMerchantDetails = yield RootStore.user?.savedMerchantDetails()
            let selectedMerchant
            let username: String

            // RESTORE PREVIOUS SELECTED MERCHANT
            if (previouslySelectedMerchantDetails && previouslySelectedMerchantDetails !== null) {
              selectedMerchant = JSON.parse(previouslySelectedMerchantDetails)
              const savedMerchantMid = selectedMerchant?.mid

              // Does any of the mid of valid merchant matches with mid of saved merchant
              isMidAvailableAndUnblocked = validMerchantData.some((merchant: any) => merchant?.mid === savedMerchantMid)

              if (isMidAvailableAndUnblocked) {
                //if Available
                username = selectedMerchant?.businessName
              } else {
                // If stored user mid is not available on the new mid list. take new mid list and consider fist active mid
                selectedMerchant =
                  self.merchants.find((element) => element?.status === 'Active' && element.userStatus === 'Active') ??
                  self.merchants[0]
                username =
                  self.merchants?.length === 1 ? self.merchants[0]?.businessName : selectedMerchant?.businessName
                //RootStore?.user?.session?.logout()
              }
            }
            // If there are no previously saved merchants
            else {
              /**The first part would be always true because we have a check in login that if only there are more than one active
               * merchant then only allow the user to login.*/
              selectedMerchant =
                self.merchants.find((element) => element?.status === 'Active' && element.userStatus === 'Active') ??
                self.merchants[0]
              username = self.merchants?.length === 1 ? self.merchants[0]?.businessName : selectedMerchant?.businessName
            }
            self.selectedMid = selectedMerchant?.mid ?? ''
            self.selectedTid = selectedMerchant?.tId ?? ''
            yield (self as any).updateVpaFromStore()
            RootStore.settings.metaData.updateSelectedMercName(username ?? '')
            RootStore.settings.metaData.updateSelectedMercStatus(selectedMerchant?.status ?? '')
            const midData = {
              mid: selectedMerchant?.mid ?? '',
              tId: selectedMerchant?.tId ?? '',
              businessName: username ?? '',
              status: selectedMerchant?.status ?? '',
            }
            if (!isOsMobile()) {
              window?.localStorage?.setItem('midData', JSON.stringify(midData))
            }
          } else {
            //If there are no valid user with available mid's then logout the user
            RootStore?.response?.setMessage('No valid merchant linked')
            RootStore?.user?.session?.logout()
            return
          }
        } else {
          //This part is a surity check for availability of mid. During deployment of new build we might not have any mid passed so in that case logout user so they can do a fresh login.
          RootStore?.user?.session?.logout()
          throw new Error('Error while processing request')
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.message ?? customError.errorOccured)
        RootStore?.user?.session?.logout()
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return data
    }),
    retrieveSplitStatusOnMid: flow(function* retrieveSplitStatusOnMid(mid: string) {
      try {
        const response = yield getSplitPayemntEnabledForMid(
          mid,
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
        )
        RootStore.settings.metaData.updateIsSplitSettlementsEnabled(response)
        return response
      } catch (e) {
        RootStore.settings.metaData.updateIsSplitSettlementsEnabled(false)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
    }),
    loadInitials: flow(function* loadInitials(isMobile: boolean, splitEnabled: boolean) {
      const postData = {
        jfsUserId: self?.session.jfsUserId,
        entityId: self?.selectedMid,
      }
      yield RootStore.userManagement.getUserPermissions(postData, isMobile)
      if (RootStore?.userManagement?.hasSupersetPermission()) {
        yield RootStore?.superset?.getAllDashboardAsync()
      } else {
        try {
          yield self?.fetchSubMerchants(self?.selectedMid)
          if (splitEnabled) {
            yield self?.retrieveSplitStatusOnMid(self?.selectedMid)
          }
        } catch (error) {
          console.error('error while fetching retrieveSplitStatusOnMid =', error)
        }
      }
    }),
    updateKycConsentAsync: flow(function* updateKycConsentAsync() {
      const requestBody = {
        identificationNumber: self?.selectedMid,
        consentId: '1',
        jpsUserId: self?.session.jfsUserId,
      }
      try {
        yield updateKycConsentApi(requestBody)
        console.log('htag saving key', `KYC_ACCEPTED-${RootStore?.settings?.metaData?.mobileNumber}`)
        yield storeData(`KYC_ACCEPTED-${RootStore?.settings?.metaData?.mobileNumber}`, 'true')
      } catch (error) {
        console.error('error while updateKycConsentAsync =', error)
        RootStore?.response?.setMessage(error?.message ?? customError.errorOccured)
        throw error
      }
    }),

    updateRole(role: Role): void {
      const own = self
      own.role = role
    },
    addAppUser: flow(function* addAppUser(appUser: any) {
      let response
      try {
        response = yield addUser(appUser, RootStore.user.session.getTokens, RootStore.user.session.userAccessToken)
        const responseObj = response
        console.log(responseObj)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),

    deleteAppUser: flow(function* deleteAppUser(userId: string) {
      let response
      try {
        response = yield deleteUser(userId, RootStore.user.session.getTokens, RootStore.user.session.userAccessToken)
        console.log(response)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),

    updateAppUser: flow(function* updateAppUser(appUser: any) {
      let response
      try {
        response = yield updateUser(appUser, RootStore.user.session.getTokens, RootStore.user.session.userAccessToken)
        console.log(response)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    // TODO: Need to move
    fetchIntentID: flow(function* fetchIntentID(amount) {
      let response
      try {
        response = yield createIntent(
          RootStore.user.session.getTokens,
          RootStore.settings.metaData.mobileNumber,
          amount,
          self.selectedMid,
          RootStore.settings.metaData.selectedMercName,
        )
        if (response?.transaction?.status === 'FAILED') {
          throw new Error(response?.transaction?.failureMessage ?? 'Error while processing request')
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw {
          data: {
            error: {
              message: response?.transaction?.failureMessage ?? customError.errorOccured,
            },
          },
        }
      }
      return response?.transaction?.id ?? ''
    }),
    getQrCode: flow(function* getQrCode(amount?: any) {
      try {
        let intentId = ''
        if (amount) {
          intentId = yield RootStore.user.fetchIntentID(amount)
        }
        const data = getQrCodeRequest(
          self.selectedMid,
          amount,
          intentId,
          'BASE64',
          RootStore.settings.metaData.mobileNumber,
        )
        let response
        response = yield generateQr(data, RootStore.user.session.getTokens)
        if (response && response?.vpa?.length > 0) {
          RootStore.settings.metaData.updateMerchantQrAndVpa(response ?? '')
          const vpaData = yield getFromStore('vpa')
          storeData('vpa', { ...(vpaData && JSON.parse(vpaData)), [self.selectedMid]: response?.vpa })
        }
        const modifiedResponse = {
          ...response,
          id: intentId,
        }
        return modifiedResponse
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw e
      }
    }),
    downloadQRCode: flow(function* downloadQRCode(amount, intentId, isShare = false) {
      const data = getQrCodeRequest(self.selectedMid, amount, intentId, 'PDF', RootStore.settings.metaData.mobileNumber)
      let response
      try {
        response = yield downloadQr(data, RootStore.user.session.getTokens, self.selectedMid, isShare)
        if (response.status === 200 && !response?.sessionExists) {
          yield appUserSessionRefresher()
          return yield (self as any).downloadQRCode(amount, intentId, isShare)
        } else if (response.status !== 200) {
          throw response
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw e
      }
      return response
    }),

    downloadAllInOneQr: flow(function* (amount, intentId) {
      let isFileDownloading = true
      let resp
      const reqBody = getQrCodeRequest(
        self.selectedMid,
        amount,
        intentId,
        'PDF',
        RootStore.settings.metaData.mobileNumber,
      )
      try {
        resp = yield downloadUniversalQr(RootStore.user.session.getTokens, reqBody)
        // Below is to check the errorcode in the response as its arraybuffer-
        if (window && resp && resp?.data) {
          downloadQrPdfFile(resp)
          isFileDownloading = false
        }
      } catch (error) {
        isFileDownloading = true
        throw error
      }
      return isFileDownloading
    }),

    deleteAppUserDetails(index: number): void {
      RootStore.deleteUser(index)
    },
    getBanksWithMobile: flow(function* getBanksWithMobile(bankId: string) {
      RootStore.settings.metaData.setProgress()
      RootStore.settings.metaData.updateSelectedBankId(bankId)
      let response
      try {
        response = yield getUserAccountDetails(bankId, RootStore.settings.metaData.mobileNumber)
        RootStore.settings.metaData.setProgress()
        RootStore.settings.metaData.updateBankList(response)
      } catch (e) {
        console.log('e?.data?.error?.message', e)
        RootStore.settings.metaData.setProgress()
        // throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    /*
 create Merchant func receives accNumber in case we get banks
 in getBanksWithMobile call and will retrive values from bankList ,
 otherwise from form screen we will pass values in second argument

*/
    createMerchant: flow(function* createMerchant(mid, accObj) {
      //  TODO: Add API request and body
      let response
      try {
        response = yield createMerchantReq(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          mid,
          accObj,
        )
        console.log(response)
        if (response?.status === SUCCESS_RESPONSE_STRING) {
          return response
        } else {
          throw new Error(response?.error?.message ?? 'Error while processing request')
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
    }),

    fetchIfsc: flow(function* fetchIfsc(data: any) {
      let response
      try {
        response = yield fetchIFSC(RootStore.user.session.getTokens, RootStore.user.session.userAccessToken, data)
        self.ifscData = response
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),

    searchIfscThroughBranchId: flow(function* searchIfscThroughBranchId(data: any) {
      let responseData
      try {
        responseData = yield searchIfscThroughBranchIdRequest(data)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return responseData
    }),

    validateIFSC: flow(function* validateIFSC(ifsc: any) {
      let response
      try {
        response = yield getBranchDetailsByIfsc(
          ifsc,
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
        )
        console.log('validateIFSC', response)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),

    removeBankAccount: flow(function* removeBankAccount(data: any) {
      //  TODO: Add API request and body
      let response
      try {
        response = yield removeBankAccountReq(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          data,
        )
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    getMerchentConfig: flow(function* getMerchentConfig() {
      let response = defaultSoundSdk
      try {
        response = yield getNotifConfig(RootStore.user.session.getTokens)
      } catch (e) {
        console.log(e)
      }
      if (isOsMobile()) {
        NotificationServiceModule?.setNotificationSettings('OPTED_SDK', response)
      }
      return response
    }),

    getAccountDetails: flow(function* getAccountDetails(data: any) {
      //  TODO: Add API request and body
      let response
      const mobile = RootStore.settings.metaData.mobileNumber
      try {
        response = yield getAccDetails(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          data,
          mobile,
        )
        console.log('response', response)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    resetInactivityTimer: () => {
      self.inactiveTime = 0
    },
    updateInactivityTime: (time: number) => {
      self.inactiveTime = time
    },
    createUserDevice: flow(function* createUserDevice(
      appId: string,
      appType: string,
      deviceId: string,
      deviceToken: string,
      osName: number,
    ) {
      let response
      try {
        response = yield createUserDeviceReq(
          RootStore.user.session.getTokens,
          appId,
          appType,
          deviceId,
          deviceToken,
          osName,
        )
        console.log('createUserDeviceReq', response)
      } catch (e) {
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    updateUserDevice: flow(function* updateUserDevice(deviceId: string, appId: string, status: number) {
      let response
      try {
        response = yield updateUserDeviceReq(RootStore.user.session.getTokens, deviceId, appId, status)
        console.log('updateUserDeviceReq', response)
      } catch (e) {
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    updateSelectedMercMid(id: string): void {
      const own = self
      own.selectedMid = id
    },
    updateSelectedMercTid(id: string): void {
      const own = self
      own.selectedTid = id
    },
    updateConsentCheckbox(val: boolean): void {
      self.consentCheckboxChecked = val
    },

    setPasswordOnIDAM: flow(function* setPasswordOnIDAM(mobile: string, password: string, otp: string) {
      let response
      try {
        response = yield setPasswordOnIDAMReq(mobile, password, otp, RootStore.user.session.getTokens)
        if (response && response.error) {
          RootStore?.response?.setMessage(response?.error?.message ?? customError.errorOccured)
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
      }
      return response
    }),
    setShowRegeneratedQr: function (show: boolean) {
      self.showRegeneratedQr = show
    },
    setSecondaryUser: function (isSecondaryUser: boolean) {
      self.secondaryUser = isSecondaryUser
    },
  }))

  .views((self) => ({
    getUserFullName(): string {
      return `${self.firstName} ${self.lastName}`
    },
    getNotifications(): NotificationV2[] {
      return self.notifications
    },
    getNotificationCount(): number {
      return self.notifications?.filter((item) => item?.isRead === false)?.length
    },
    getDisplayCount(): string {
      const count = self.notifications?.filter((item) => item?.isRead === false)?.length
      return count > 9 ? '9+' : count.toString()
    },

    sortedMerchants(searchString: string): MerchantType[] {
      let merchants: any = self.merchants
      if (searchString?.length > 0) {
        merchants = self.merchants?.filter(
          (item: any) =>
            item?.businessName?.toLowerCase()?.includes(searchString?.toLowerCase()) ||
            item?.mid?.includes(searchString),
        )
      }

      return merchants.slice().sort((a) => compareBusiness(a))
    },
    removeMerchantDetailsFromLocalStorage(): any {
      window.localStorage.removeItem('merchantData')
    },
    saveMerchantDetailsToLocalStorage(data: any): any {
      window.localStorage.setItem('merchantData', JSON.stringify(data))
    },
    async savedMerchantDetails() {
      if (isOsMobile()) {
        const merchantData = await AsyncStorage.getItem('midData')
        return merchantData
        // return null
      } else {
        const merchData = window.localStorage.getItem('merchantData')
        return merchData
      }
    },
    get isVerifiedSession(): boolean {
      return self.session.isVerified
    },
    get isToken(): string {
      return self.session.userAccessToken
    },
    get settlementAccount() {
      let acNu = ''
      self?.merchants?.forEach((item) => {
        if (item?.mid === self.selectedMid) {
          acNu = item?.bankAccount?.number ?? ''
        }
      })
      if (acNu === '') {
        return null
      }
      const length = acNu.length
      return '******' + acNu.slice(length - 4) //as per user stories!
    },
    userBankAccountDetail(): string {
      // return `${self.bank?.accountNumber}` //TODO: update when API returns data and we start storing then in actual modals.
      return '1091000100256472'
    },

    merchantData(): any {
      let counterArray: any[] = []
      self.merchants?.map((merchant) => {
        if (merchant.isValidMerchant()) {
          counterArray.push(merchant)
        }
      })
      return counterArray
    },

    getMidForAddBank() {
      const mid = self?.selectedMid ?? ''
      const merchants = self.merchants
      if (mid === '' && merchants.length === 1) {
        return merchants[0].mid
      }
      return mid
    },
    getAccounts() {
      const data = RootStore.user.merchants.find((item: any) => item.mid === self.selectedMid)?.bankAccount
      return [
        {
          bankName: data?.bank.name,
          bankId: data?.bank.id,
          ifsc: data?.bank.ifsc,
          number: data?.number,
          accountType: data?.type,
        },
      ]
    },
    isSettlementAccountAdded() {
      const data = RootStore.user.merchants.find((item: any) => item.mid === self.selectedMid)?.bankAccount
      //console.log('bank data added ==> ', data, self.selectedMid)
      return data?.number ? true : false
    },
    getSubMerchants(): any {
      const superMerchant = self.merchants.find((item: any) => item.mid === self.selectedMid && self.isSmid)
      const subMids = superMerchant?.subMids ?? []
      const parsedSubMids: any = {}
      subMids?.map((item: any) => {
        parsedSubMids[item.mid] = item
      })
      return parsedSubMids
    },
  }))

const userInitialData = User.create({
  id: '1',
  documents: [documentV2],
  firstName: '',
  institutionId: '1',
  lastName: '',
  notifications: [notificationDataV2, notificationData0V2],
  permissions: [],
  role: Role.Admin,
  status: MerchantStatus.Inactive,
  session: sessionDataV2,
  ifscData: [],
  inactiveTime: 0,
  selectedMid: '', // '100001000217423', //Check
  selectedTid: '',
  merchants: [],
  consentCheckboxChecked: true,
  secondaryUser: false,
})

const userInitialData1 = User.create({
  id: '2',
  documents: [],
  firstName: '',
  institutionId: '2',
  lastName: '',
  notifications: [],
  permissions: [],
  role: Role.Ops,
  status: MerchantStatus.Inactive,
  session: sessionDataV21,
  inactiveTime: 0,
  selectedMid: '', // '100001000217423', //Check
  selectedTid: '',
  merchants: [],
  consentCheckboxChecked: true,
  isSmid: false,
})

export { User, userInitialData, userInitialData1 }
export type UserV2 = Instance<typeof User>
